import React, {Component} from 'react';
import '../less/membGrade.less'

class SpanList extends Component {
  render() {
    return (
      <p>
        {
          this.props.spanList.map((item, index) => {
            return (
              <span key={index+1}>{item}</span>
            )
          })
        }
      </p>
    )
  }
}

class Table1 extends Component {
  render() {
    return (
      <div className="membGrade-body">
      {
        this.props.tableList.map((item, index) => {
          return (
            <div className="body-line" key={index}>
              <div className='body-item b-item1'>
                <img src={item.img}/>
              </div>
              <div className='body-item b-item2'>
                <SpanList spanList={item.item2}/>
              </div>
              <div className='body-item b-item3'>
                <SpanList spanList={item.item3}/>
              </div>
              {/* <div className='body-item b-item4'>
                <SpanList spanList={item.item4}/>
              </div>
              <div className='body-item b-item5'>
                <SpanList spanList={item.item5}/>
              </div> */}
            </div>
          )
        })
      }
      </div>
    )
  }
}
class MembGrade extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tableCurrent: [
        {
          img: require('../images/club/w-bluex3.png'), 
          item2: ['12 months'],
          item3: ['-'],
          // item4: ['-'],
          // item5: ['Members who fail to sign in WeHotel platform within the validity period will be downgraded to registered user.']
        },
        {
          img: require('../images/club/w-silverx3.png'), 
          item2: ['12 months'],
          item3: ['3 nights / ¥ 1,000 actual payment amount'],
          // item4: ['3 nights / ¥ 1000 spending'],
          // item5: ['Members who fail to earn 3 nights or ¥ 1000 spending within the validity period will be downgraded to BLUE.']
        },
        {
          img: require('../images/club/w-goldx3.png'), 
          item2: ['12 months'],
          item3: ['10 nights / ¥ 3,000 actual payment amount'],
          // item4: ['10 nights / ¥ 3000 spending'],
          // item5: ['Members who fail to earn 10 nights or ¥ 3000 spending within the validity period will be downgraded to SILVER.']
        },
        {
          img: require('../images/club/w-platinumx3.png'), 
          item2: ['12 months'],
          item3: ['30 nights / ¥ 20,000 actual payment amount'],
          // item4: ['20 nights / ¥ 20,000 spending'],
          // item5: ['Members who fail to earn 20 nights or ¥ 20,000 spending within the validity period will be downgraded to GOLD.']
        }
      ],
      activeIndex: 1
    }
  }

  render() {
    return (
      <div className="membGrade-main">
        <h4>Member Tiers</h4>
        <div className="membGrade-content">
          <div className="membGrade-header tab2">
            <div className="header-item h-item1"><p>Member Tier</p></div>
            <div className="header-item h-item2"><p>Membership Validity</p></div>
            <div className="header-item h-item3"><p>Upgrade</p></div>
            {/* <div className="header-item h-item4"><p>Maintain the Current Tier</p></div>
            <div className="header-item h-item5"><p>Downgrade</p></div> */}
          </div>
          <Table1 tableList={this.state.tableCurrent}/>
          <div className="membGrade-note">
            <div className="membGrade-nodeArea">
              <h3>Note</h3>
              <p>1. Nights: room nights may be earned for members who have an eligible booking and stay in person via Jin Jiang official website/APP/WeChat/customer service hotlines.</p>
              <p>2. Actual payment amount: Actual payment amount may be earned for members who have an eligible booking and stay in person via Jin Jiang official website/APP/WeChat/customer service hotlines or the actual order amount of the completed order in Jin Jiang Mall.</p>
              <p>3. Membership will be upgraded the next day after upgrade requirements are met, the room nights and spending will be reset after the upgrade.</p>
              <p>4. When the membership is due, corresponding room nights and spending will be deducted to maintain the membership tier.</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MembGrade